import date from "../../../../functions/dateFormat";

export default ({names, namesList, setNamesList}) => {

    function AddOrRemoveName (value) {
        if (value in namesList) {
            let n = {...namesList};
            delete n[value];

            setNamesList(n);
        } else {
            setNamesList({...namesList, [value]: 
                {name: `${names[value]['firstName']} ${names[value]['lastName']}`, dob: names[value]['dob'], credit: names[value]['credit']}
            });
        }
    }

    return (
        <table className="table-add-names-inDocket">
            <thead>
                <tr>
                    <td></td>
                    <td> שם </td>
                    <td> תאריך לידה </td>
                </tr>
            </thead>
            <tbody>
                {
                    Object.keys(names).map((value, key) => 

                    <tr key={key} onClick={() => AddOrRemoveName(value)} >
                        <td> <input type={'checkbox'} checked={value in namesList} /> </td>
                        <td key={2}> { `${names[value]['firstName']} ${names[value]['lastName']}` } </td>
                        <td key={3}> { date(names[value]['dob']) } </td>
                    </tr>
                    )
                }
            </tbody>
        </table>
    )
}